import {dateTime, duration} from "services/date";
import {Visit} from "../../../types/Visit";
import deserializeVisitActivityEntry from "./visit-activity";

/**
 * Transform the given visit by deserializing object properties
 *
 * @internal
 * @param visit
 */
export default function deserializeVisit(visit: any): Visit {
    visit.duration = duration(visit.duration)
    visit.started_at = dateTime(visit.started_at)
    visit.extended_at = dateTime(visit.extended_at)
    visit.ended_at = dateTime(visit.ended_at)
    visit.plan_starts_at = dateTime(visit.plan_starts_at)
    visit.plan_ends_at = dateTime(visit.plan_ends_at)
    visit.created_at = dateTime(visit.created_at)
    visit.updated_at = dateTime(visit.updated_at)
    visit.activity = visit.activity?.map(deserializeVisitActivityEntry)

    return visit;
}